import { useState, useEffect } from 'preact/compat'
import { useDispatch, useSelector } from 'react-redux'
import {
  authoriseError,
  clearAuthoriseData,
  updatePaymentPending,
 paymentResponseSelector } from '../redux/slice/paymentResponseSlice'
import { paymentPay } from '../redux/slice/paymentSlice'
import useCardinal from './useCardinal'
import { redirect } from '../helpers/common'
import {
  ERROR_RESPONSES,
  SUCCESS_RESPONSES,
} from '../constants/serverResponses'
import { DataDog } from '../datadog'
import { billingAddressSelector } from '../redux/slice/billingAddressSlice'
import { cardinalCruiseSelector } from '../redux/slice/cardinalCruiseSlice'
import { transactionDetailsSelector } from '../redux/slice/transactionDetailsSlice'

export default function usePayment(iframeRef) {
  const [hasCharged, setChargedState] = useState(false)
  const [isPayButtonVisible, setPayButtonVisible] = useState(true)
  const dispatch = useDispatch()
  const transactionDetails = useSelector(transactionDetailsSelector)
  const paymentResponse = useSelector(paymentResponseSelector)
  const cardinalCruise = useSelector(cardinalCruiseSelector)
  const billingAddress = useSelector(billingAddressSelector)
  const { is3dsRequired, successUrl } = transactionDetails

  useEffect(() => {
    if (paymentResponse.hasResponse) {
      if (!paymentResponse.hasError) {
        if (
          paymentResponse.threeDsEnrollment &&
          +paymentResponse.threeDsVersion === 2
        ) {
          dispatch(updatePaymentPending(false))
          setPayButtonVisible(false)

          window.Cardinal.continue(
            'cca',
            {
              AcsUrl: paymentResponse.acsUrl,
              Payload: paymentResponse.paReq,
            },
            {
              OrderDetails: {
                TransactionId: paymentResponse.authenticationTransactionId,
              },

              Consumer: {
                BillingAddress: {
                  Address1: billingAddress?.addressLine1,
                  Address2: billingAddress?.addressLine2,
                  City: billingAddress?.city,
                  PostalCode: billingAddress?.postalCode,
                  CountryCode: billingAddress?.country,
                },
              },
            },
          )
        }

        if (!paymentResponse.threeDsEnrollment) {
          DataDog.info(
            `Redirection. usePayment (has payment response), redirect url: ${successUrl}`,
          )

          if (paymentResponse?.responseStatus === SUCCESS_RESPONSES.OK) {
            redirect(successUrl)
          } else {
            dispatch(
              authoriseError({
                responseStatus: ERROR_RESPONSES.SERVER_ERROR,
              }),
            )
          }
          return
        }
        setChargedState(true)

        dispatch(clearAuthoriseData())
      } else {
        setChargedState(false)
      }
      setPayButtonVisible(paymentResponse?.isRetryable)
    }
  }, [paymentResponse.hasResponse])

  const initCardinal = useCardinal({ setPayButtonVisible })

  useEffect(() => {
    if (cardinalCruise.successRedirectUrl) {
      DataDog.info(
        `Redirection. usePayment (cardinal success scenario), redirect url: ${cardinalCruise.successRedirectUrl}`,
      )
      redirect(cardinalCruise.successRedirectUrl)
    }
  }, [cardinalCruise.successRedirectUrl])

  const proceedPayment = async (onSuccess, onFailure, overrideValues) => {
    setPayButtonVisible(false)
    dispatch(updatePaymentPending(true))
    if (!is3dsRequired) {
      console.log('onSuccess1', onSuccess)
      console.log('onFailure1', onFailure)

      return dispatch(
        paymentPay({ onSuccess, onFailure, iframeRef, overrideValues }),
      )
    }
    await initCardinal(() =>
      dispatch(paymentPay({ onSuccess, onFailure, iframeRef, overrideValues })),
    )
  }

  return {
    hasCharged,
    setChargedState,
    isPayButtonVisible,
    proceedPayment,
  }
}
